/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

import { useTranslation } from 'react-i18next';
import { ActionIcon, Center } from '@mantine/core';

import { IconDotsVertical as IconMore } from '@tabler/icons-react';

import { CellProps, TableMeta } from '../types';
import ResourceContextMenu from '@features/Resource/ResourceContextMenu';
import { palette } from '@app/shared/ui-kit/colors';
import { useResourceFilteredActions } from '@app/features/Resource/hooks/useResourceFilteredActions';
import { ResourceRowFragmentFragment } from '@app/types/blackroom-api';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */

function CellActions({ row, table }: CellProps<ResourceRowFragmentFragment>) {
  /* ***************************** LOCAL VARIABLES **************************** */

  const { t } = useTranslation(['Common']);
  const resource = row.original;

  const context = (table.options?.meta as TableMeta).context;
  const menuOffset = { mainAxis: -30, crossAxis: 10 };
  const { allowedActions } = useResourceFilteredActions({
    resources: [resource],
    scope: context.scope,
  });

  /* **************************** RENDERING HELPERS *************************** */
  const menuTarget = (
    <ActionIcon
      variant="transparent"
      size="sm"
      radius={0}
      aria-label={t('Common:actions.moreActions')}
    >
      <IconMore color={palette.blackroomLightGray2} />
    </ActionIcon>
  );
  /* ******************************** RENDERING ******************************* */
  return (
    <Center w="100%">
      <ResourceContextMenu
        position="bottom-end"
        resources={[resource]}
        allowedActions={allowedActions}
        offset={menuOffset}
        target={menuTarget}
        scope={context.scope}
      />
    </Center>
  );
}

export default CellActions;
